import { SectionItemI, ItemI } from "../../shared";

export const getElementOffset = (brackets: SectionItemI['brackets'], parts?: ItemI[]): number => {
    if (!parts) return 0

    const elements = [
        ...brackets.left.elements,
        ...brackets.right.elements
    ].map((e) => e.bitrixId)
       .filter((v, i, a) => a.indexOf(v) === i);
    const elementHeight = parseFloat(parts.find((part) => part.BITRIX_OFFER_ID === elements[0])?.PROPERTIES.HEIGHT || '0') / 1000;
    const elementPosition = Array.isArray(brackets.right.position) ? brackets.right.position[2] : 0;

    return elementHeight - elementPosition
}
